<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Códigos</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-header p-2 ml-2 mt-2">
        <div class="d-flex flex-row justify-content-between align-items-center">
          <h5><strong>Eliminar venta</strong></h5>
          <b class="mr-3">{{ moment.utc(codeExpirationTime * 1000).format("mm:ss")}}</b>
        </div>
      </div>
      <div class="card-body p-0">
        <div v-if="code">
          <div class="d-flex flex-row mb-2 mt-3">
            <span class="my-auto mx-3">Código actual: <b>{{ code }}</b></span>
            <div class="p-0 m-0 d-flex" style="gap: 0.7em;">
              <b-button variant="outline-success" class="border-0 rounded-sm" @click="renewCode()">
                <i class="fa fa-exchange mr-2" aria-hidden="true" />Obtener un nuevo código</b-button>
            </div>
          </div>
          <small class="d-flex ml-3 mb-3 mr-2" style="font-size: 0.93em;"><i class="fa fa-info-circle mr-1 mt-0" aria-hidden="true" />
            Código de un solo uso que se actualiza automáticamente tras ser utilizado. <br/> Se obtiene el código vigente cada minuto. <br/>
          </small>
        </div>
        <div v-else class="text-center my-3">
          <p class="text-center">No hay código disponible.</p>
          <b-button variant="outline-primary" class="rounded-sm" @click="createCode()">
            Generar código</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apiClient2 from '@/services/axios/v2'
import { mapState } from 'vuex'
import { ToastFire } from '@/services/utilities/swal'
import moment from 'moment'

export default {
  name: 'codeAdmin',
  data() {
    return {
      code: null,
      initLoading: false,
      initCode: false,
      codeExpirationTime: 0,
      isCreated: false,
      interval: null,
      moment,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  watch: {
    isCreated(newValue) {
      if (this.initCode) return
      if (newValue) {
        this.interval = setInterval(() => {
          this.delayCode()
        }, 1000)
      }
    },
  },
  methods: {
    delayCode() {
      if (this.codeExpirationTime > 0) {
        this.codeExpirationTime = this.codeExpirationTime - 1
      } else {
        this.refreshCode()
      }
    },
    refreshCode() {
      apiClient2.get(`/users/${this.user.id}/get-code`).then((response) => {
        const codeStr = response.data.data.code.toString()
        this.code = `${codeStr.slice(0, (codeStr.length / 2))} - ${codeStr.slice((codeStr.length / 2))}`
        this.codeExpirationTime = 60
        if (this.initLoading) {
          ToastFire('success', 'Código actual obtenido exitosamente')
        } else this.initLoading = true
      }).catch(error => {
        console.error('Error al obtener el código:', error)
        ToastFire('error', 'Error al obtener el código')
      })
    },
    renewCode() {
      apiClient2.patch('/users/update-code').then((response) => {
        this.codeExpirationTime = 60
        const codeStr = response.data.data[0].code.toString()
        this.code = `${codeStr.slice(0, (codeStr.length / 2))} ${codeStr.slice((codeStr.length / 2))}`
        ToastFire('success', 'Código renovado exitosamente')
      }).catch(error => {
        console.error('Error al renovar el código:', error)
        ToastFire('error', 'Error al renovar el código')
      })
    },
    createCode() {
      apiClient2.post('/users/new-code').then((response) => {
        const codeStr = response.data.data.code.toString()
        this.code = `${codeStr.slice(0, (codeStr.length / 2))} ${codeStr.slice((codeStr.length / 2))}`
        ToastFire('success', 'Código generado exitosamente')
        this.codeExpirationTime = 60
        this.isCreated = true
      }).catch((error) => {
        ToastFire('warning', error.response.data.error.message)
      })
    },
  },
  async mounted() {
    await apiClient2.get(`/users/${this.user.id}/get-code`).then((response) => {
      if (response.data.data) {
        const codeStr = response.data.data.code.toString()
        this.code = `${codeStr.slice(0, (codeStr.length / 2))} ${codeStr.slice((codeStr.length / 2))}`
        this.codeExpirationTime = 60
        this.initCode = true
        this.isCreated = true
        this.initLoading = true
      }
    })
    if (this.isCreated) {
      this.interval = setInterval(() => {
        this.delayCode()
      }, 1000)
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
}
</script>
